var map = {
	"./banner_logo.png": 86931,
	"./facup_ico.png": 16384,
	"./ico_facup.png": 91236,
	"./jdfc_koreacup_2024.png": 80982,
	"./jdfc_koreacup_2025.png": 35185,
	"./kleague_ico.png": 73583,
	"./logo_gray.png": 35700,
	"./match_bg.png": 12435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77046;